import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  FormHelperText
} from "@material-ui/core";

const stateTypes = ["btax", "courses"];

const AddNewProductStatePopup = (props) => {
  return (
    <Dialog open={props.isAddNewPopupOpen} onClose={props.handleClose}>
      <DialogContent style={{ display: "flex", flexDirection: "column", width: "500px" }}>
        <TextField
          autoFocus
          style={{ marginBottom: "10px" }}
          value={props.newProductStateInfo.stateName || ""}
          label="State Name (English)"
          variant="standard"
          onChange={(e) => props.onChange("stateName", e.target.value)}
          error={Boolean(props.formatErrors.stateName)}
          helperText={props.formatErrors.stateName}
        />
        <TextField
          style={{ marginBottom: "10px" }}
          value={props.newProductStateInfo.stateHeb || ""}
          label="State Name (Hebrew)"
          variant="standard"
          onChange={(e) => props.onChange("stateHeb", e.target.value)}
          error={Boolean(props.formatErrors.stateHeb)}
          helperText={props.formatErrors.stateHeb}
        />
        <FormControl style={{ marginBottom: "10px" }} error={Boolean(props.formatErrors.usedInProducts)}>
          <InputLabel>Choose State Type</InputLabel>
          <Select
            multiple
            value={props.newProductStateInfo.usedInProducts || []}
            onChange={(e) => props.onChange("usedInProducts", e.target.value)}
            variant="standard"
            renderValue={(selected) => selected.join(", ")}
          >
            {stateTypes.map((type) => (
              <MenuItem key={type} value={type}>
                <Checkbox color="primary" checked={props.newProductStateInfo.usedInProducts?.indexOf(type) > -1} />
                <ListItemText primary={type} />
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{props.formatErrors.usedInProducts}</FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions style={{ justifyContent: "space-between" }}>
        <Button onClick={props.handleAdd} color="primary" variant="contained" style={{ marginRight: "8px" }}>
          Add
        </Button>
        <Button onClick={props.handleClose} style={{ background: "#fbae08", color: "white" }} variant="contained">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNewProductStatePopup;
